<template>
  <div class="result">

    <div uk-grid class="uk-margin">
      <div class="uk-width-1-6@s no-print">
        <img alt="logo" :src="logo" style="max-width:450px" width="90%">
      </div>
      <div class="uk-width-5-6@s no-print">
        <h2>RESULTADO DE ANÁLISIS DE CAPACIDAD DE PAGO</h2>
      </div>
      <div class="uk-width-1-6 print-only">
        <img alt="logo" :src="logo" style="max-width:450px" width="90%">
      </div>
      <div class="uk-width-5-6 print-only">
        <h2>RESULTADO DE ANÁLISIS DE CAPACIDAD DE PAGO</h2>
      </div>
    </div>
    

    

    <p v-if="loading"> <span uk-spinner="ratio:3"></span> </p>
  <div v-else>
    <div id="res">

    <p class="uk-text-left">Nombre: {{name}} <br> Fecha de registro: {{date}} <span class="print-only">  Ingreso neto: {{ing}} <br>Egresos: {{egg}}</span> </p>
 

    <div>
    <h3  >  ¡Sí, puedes hacer tu meta realidad! Decídete ahora</h3>



    </div>
    

    <h3>TABLA DE DATOS</h3>

    <table class="uk-table uk-table-divider uk-table-hover">
      <tbody>
        <tr>
          <td>
            Finalidad
          </td>
          <td>
            {{data['Finalidad']}}
          </td>
        </tr>
        <tr>
          <td>
            1 Total Ingresos
          </td>
          <td>
            {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat( data['1 Total Ingresos']) )}}
          </td>
        </tr>
        <tr>
          <td>
            2 Total Gastos
          </td>
          <td>
            {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat( data['2 Total Gastos']) )}}
          </td>
        </tr>
        <tr style="background-color:lightyellow">
          <td>
            3 Saldo Disponible
          </td>
          <td>
            {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat( data['3 Saldo Disponible']) )}}
          </td>
        </tr>
        <tr>
          <td>
            4 Monto solicitado
          </td>
          <td>
            {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat( data['4 Monto solicitado']) )}}
          </td>
        </tr>
        <tr>
          <td>
            5 Plazo
          </td>
          <td>
            {{ data['5 Plazo']}}
          </td>
        </tr>
        <tr style="background-color:lightyellow">
          <td>
            6 Cuota a pagar
          </td>
          <td>
            {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat( data['6 Cuota a pagar']) )}}
          </td>
        </tr>



        
      </tbody>
    </table>
      <p>Este resultado aplica restricciones y solo es de carácter informativo. <br> Solicita asesoría en tu sucursal</p>
    </div>

    <div class="uk-text-center uk-child-width-1-2@s no-print uk-match" uk-grid>
      

 <div v-if="!fromMail">
          <p>
          <a class="uk-button uk-button-large uk-button-primary uk-border-rounded" style="background-color: #6636cf; color:white" :href="'http://allappsvirtual.web.app/integral/solicitud/app/' + now" >Continuar a solicitud online</a>
          </p>
        </div>

        <div class="uk-margin">
          <p>Contacta a tu cooperativa por WhatsApp, da click al botón:</p>
          <button type="button" v-on:click="wa" style="background-color: #25D366;  color:white" class="uk-button uk-button-primary uk-border-rounded" :uk-tooltip='"+"+telefono' ><span style="color:white" uk-icon="icon:whatsapp;ratio:2" class="uk-margin-small-top uk-margin-small-bottom"></span></button>
          <p> (+{{telefono}})</p>
        </div>



    </div>

        <div class="uk-align-center no-print" style="width:100%">
        <div uk-slider="autoplay: true; autoplay-interval: 3000; center: true;">
            <ul class="uk-slider-items uk-grid uk-grid-medium uk-child-width-1-3@m" >
                <li v-for="item in pics">
                    <div>
                        <a href="#">
                            <img :src="item" alt="Promo" width="350">
                        </a>
                    </div>
                </li>
            </ul>
         </div>

        </div>


<p class="uk-text-right"><small>Los resultados expuestos en este simulador no representan una aprobación crediticia por ningún concepto y son meramente explicativos.</small></p>

    </div>
  </div>
</template>

<script>
export default {
    data: function() {
      return {
        telefono : '',

        data : {},
        
        loading : false,
        mail : '',
        now : sessionStorage.getItem('id'),
        fromMail : false,
        asalariado:this.$score.asalariado,
        date : '',
        name: '',
        ing:0,
        egg:0,
        aprob : '',
        pics:[
        ],
        logo : require('@/assets/logo.jpg'),
      }
    }, 
    computed: {
      total : function() {
        var tot = 0.0
        var count = 0
        for (var i in this.data){
          if(i != 'act' && i != 'asalariado' && i != 'RFC' && i != 'Fecha de nacimiento' && i != 'name' ) tot += parseFloat(this.data[i]['PUNTAJE TOTAL'])
        }
        return tot.toFixed(2)
      },
      color: function() {
        switch (true) {
          case this.total >= 451:
            return "#42f54e"

          case this.total > 401:
            return "#f5e042"

          case this.total > 301:
            return "#f5e042"

          case this.total > 251:
            return "#f59642"

          default:
            return "#f54242"
        }
      },
      text: function() {
        switch (true) {
          case this.total >= 451:
            return "BAJO RIESGO"

          case this.total > 401 :
            return "RIESGO MODERADO"

          case this.total > 301 :
            return "RIESGO MEDIO"

          case this.total > 251:
            return "RIESGO MEDIO ALTO"

          default:
            return "RIESGO ALTO"
        }
      },
    },
    mounted:async function(){
      window.scroll(0,0)
      this.loading = true
      

          // estas credenciales son públicas 
          // estas credenciales solo tienen acceso a la función pública del correo, al teléfono público de la empresa y a su logo
          await firebase.auth().signInWithEmailAndPassword('7c@mail.com','TfXX8MjDtwUZv1UUDNXMwmYlQW12')

        try {
          await firebase.database().ref('integral/prospecting/telefono').once('value').then(function(s){
            this.telefono = s.toJSON()
          }.bind(this))
          
        } catch (e) {
          console.log(e.message);
        }
        try {
          this.date = new Date(parseInt(sessionStorage.getItem('id'))).toLocaleString()
          this.data = JSON.parse(sessionStorage.getItem('data'))
          this.name = this.data.Nombre
          this.mail = this.data.Correo
          this.ing = this.data['1 Total Ingresos']
          this.egg = this.data['1 Total Gastos']
          this.data['Relación entre cuota y disponible'] >= 100 ? this.aprob = '¡Sí, puedes hacer tu meta realidad! Decídete ahora' : this.aprob = 'La cuota del préstamo solicitado supera tu ahorro mensual,  solicita asesoría a tu institución financiera.'
          await firebase.database().ref('integral/prospecting/prospectos/' + sessionStorage.getItem('id')).update(this.data)
        } catch (e) {
          console.log(e.message);
        }

        if(!this.data){
          this.data = {
            'Finalidad' : 'Datos incompletos'
          }
          this.name = 'Datos Incompletos'
        }

        this.loading = false
      

      ///////////////////////
      /////////////////////////
      ////////// PICS /////////


       var storage = firebase.storage().ref('integral')
      this.pics = []
        await storage.child('prospecting').listAll().then( async function(res) {
            for(var k in res.items ){
                var url = await res.items[k].getDownloadURL()
                this.pics.push(url)
            }
        }.bind(this))

    },
    methods:{
      send : async function() {
        if(this.data){
          this.loading = true


          if(this.mail){
            var sendMail = firebase.functions().httpsCallable('cuatroc') // esta es la función del correo
            var mailData = {
              mail : this.mail,
              e : 'Caja integral',
              res : document.getElementById('res').innerHTML 
            }
            await sendMail(mailData)
            UIkit.notification('Resultados enviados correctamente','success')
            this.fromMail = true
            await firebase.auth().signOut()

          } else {
            UIkit.notification('Debes ingresar una dirección de correo válida','warning')
          }


          
        } else {
          UIkit.notification('No se respondieron todas las preguntas','warning')
        }
        this.loading = false
      },
      print : function() {
        window.print()
      },
      again:function () {
        this.$score = {}
        sessionStorage.removeItem('id')
        sessionStorage.removeItem('data')
        this.$router.push('/')
      },
      wa : function(){
        
            var message = 'Hola, soy ' + this.name + '. Me interesa un crédito con ustedes. Vengo de la app PROSPECTING'             
            var s = encodeURIComponent(message)

            window.location = 'https://wa.me/'+this.telefono+'?text='+s
      },
    }
}
</script>
